import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * The event fires when the user fails to login (any login method).
 * @memberOf Playtech.API.events
 * @event auth:generic_login:error
 * @type {callback}
 * @example Playtech.on('auth:generic_login:error', (error) => { ... });
 */

export const EVENT_GENERIC_LOGIN_ERROR = 'auth:generic_login:error';

export const useOnGenericLoginError = (eventTarget: EventTarget) => {
    const handleEvent = useCallback((error: string): void => {
        const event = new CustomEvent(EVENT_GENERIC_LOGIN_ERROR, { detail: error });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on(EVENT_GENERIC_LOGIN_ERROR, handleEvent);

        return () => publicEventsAPIService.off(EVENT_GENERIC_LOGIN_ERROR, handleEvent);
    }, [handleEvent]);
};
